module.exports = __webpack_public_path__ + "img/bx-like.46cda419.svg";